import React from 'react';
import { CrmHero } from '../components/crm/CrmHero';
import { CrmProblems } from '../components/crm/CrmProblems';
import { CustomerJourney } from '../components/crm/CustomerJourney';
import { ReplaceApps } from '../components/crm/ReplaceApps';
import { WhyAdroiCrm } from '../components/crm/WhyAdroiCrm';
import { MobileAppSection } from '../components/crm/MobileAppSection';
import { CrmProof } from '../components/crm/CrmProof';
import { CrmFinalCta } from '../components/crm/CrmFinalCta';
import { ServiceFaq } from '../components/ServiceFaq';
import { crmPageFaqs } from '../data/faqs';
export function Crm() {
  return <>
      <CrmHero data-id="element-714" data-mp="2aa5hhdq7pf52" />
      <CrmProblems data-id="element-715" data-mp="2aap2x4f2mlnu" />
      <CustomerJourney data-id="element-716" data-mp="2a718m31sxv82" />
      <ReplaceApps data-id="element-717" data-mp="259rliu1vxvne" />
      <WhyAdroiCrm data-id="element-718" data-mp="2599dz19rvv06" />
      <MobileAppSection data-id="element-719" data-mp="258pyrsbibkpu" />
      <CrmProof data-id="element-720" data-mp="25cnjgidqgkbu" />
      <ServiceFaq serviceName="CRM" faqs={crmPageFaqs} data-id="element-721" data-mp="3loansddwe13k" />
      <CrmFinalCta data-id="element-722" data-mp="3lmptmovhwk68" />
    </>;
}